<template>
  <div id="app">
    <!-- <div class="openingBackground"></div>
    <p class="openingText">Welcome</p> -->

    <nav class="mobileNav">
      <button class="icon"><router-link to="/profile"><strong>kr</strong></router-link></button>
      <button @click="showNav" class="menu-icon">
        <div class="bar top"></div>
        <div class="center">
          <div class="bar one"></div>
          <div class="bar two"></div>
        </div>
        <div class="bar bottom"></div>
      </button>
      <div class="navMenu">
          <button class="navLink"><router-link to="/">SHOWCASE<span class="hover-line"></span></router-link></button>
          <button class="navLink"><router-link to="/profile">ABOUT ME<span class="hover-line"></span></router-link></button>
          <button class="navLink"><a href="https://www.linkedin.com/in/kristarowland/" target="_blank">LINKEDIN<span class="hover-line"></span></a></button>
      </div>
    </nav>

    <nav class="desktopNav">
      <button class="icon"><router-link to="/profile"><strong>kr</strong></router-link></button>
      <div class="navMenu">
          <button class="navLink"><router-link to="/">SHOWCASE<span class="hover-line"></span></router-link></button>
          <button class="navLink"><router-link to="/profile">ABOUT ME<span class="hover-line"></span></router-link></button>
          <button class="navLink"><a href="https://www.linkedin.com/in/kristarowland/" target="_blank">LINKEDIN<span class="hover-line"></span></a></button>
      </div>
    </nav>
    
    <transition
        mode="out-in"
        @enter="routeIn"
        @leave="routeOut"
        :css="false">
      <router-view/>
    </transition>
    
    
  </div>
</template>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;900&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Lobster&display=swap');
  @import './static/scss/app.scss';
</style>

<script>
import { TimelineMax  } from '@/vendor';

export default {
  name: 'App',

  data() 
  {
    return {
      mobileView: false,
      menuOpen: true
    }
  },

  mounted()
  {
    // this.openingAnim();
    window.addEventListener('resize', this.resizeHandler); 
  },

  methods:{
    // openingAnim()
    // {
    //     if (this.$route.path === "/"){
    //       let tl = new TimelineMax({ });

    //       tl.add('frame1', 0.5);
    //       tl.add('frame2', 'frame1+=2.5');
          
    //       tl.from('.openingText', 0.5, { y: 10, autoAlpha: 0 }, 'frame1');
    //       tl.to('.openingBackground', 1, { autoAlpha: 0 }, 'frame2-=1');
    //       tl.to('.openingText', 1, { autoAlpha: 0 }, 'frame2-=1');
          

    //       tl.add( () => { this.$router.push('/cases'); }, 'frame2');
    //       tl.from(['nav','footer'], 1, { autoAlpha: 0 }, 'frame2+=0.5');
    //     }
    //     else
    //     {
    //       TweenMax.set(['.openingText', '.openingBackground'], { autoAlpha: 0 });
    //     }
    // },

    routeIn(el, done){
      let tl = new TimelineMax({ onComplete:done });
      tl.from( el, 1, { scale: 1.25, autoAlpha: 0, ease: "power4.out"  }, 0);
    },

    routeOut(el, done){
      let tl = new TimelineMax({ onComplete:done });
      tl.to( el, 1, { scale: 1.25, autoAlpha: 0,  ease: "power4.out" }, 0);
    },
    resizeHandler(e) {
      this.windowWidth = e.currentTarget.innerWidth;
      // console.log( e.currentTarget.innerWidth, e.currentTarget.innerHeight);

      if( e.currentTarget.innerWidth <= 823 ){
          // console.log('I am in rotation and mobile view');
          this.mobileView = true;
      }else{
        // console.log('I am not rotation and mobile view');
        this.mobileView = false;
      }
    },
    showNav(){
      // TweenMax.set('.navLink', { autoAlpha: 0 });
      if( this.menuOpen )
      {
          let tl = new TimelineMax({ });

          tl.add('frame1', 0);
          
          tl.to('.mobileNav .navMenu', 0.5, { x: -window.innerWidth/1.9 }, 'frame1');
          tl.to('.mobileNav .menu-icon .center .bar.one', 0.5, { rotation: 40 }, 'frame1');
          tl.to('.mobileNav .menu-icon .center .bar.two', 0.5, { rotation: -40 }, 'frame1');
          tl.to('.mobileNav .menu-icon .top', 0.25, { autoAlpha: 0 }, 'frame1');
          tl.to('.mobileNav .menu-icon .bottom', 0.25, { autoAlpha: 0 }, 'frame1');
          
          this.menuOpen = false;
      }else{  
          let tl = new TimelineMax({ });

          tl.add('frame1', 0);
          
          tl.to('.mobileNav .navMenu', 0.5, { x: 0 }, 'frame1');
          tl.to('.mobileNav .menu-icon .center .bar.one', 0.5, { rotation: 0 }, 'frame1');
          tl.to('.mobileNav .menu-icon .center .bar.two', 0.5, { rotation: 0 }, 'frame1');
          tl.to('.mobileNav .menu-icon .top', 0.25, { autoAlpha: 1 }, 'frame1');
          tl.to('.mobileNav .menu-icon .bottom', 0.25, { autoAlpha: 1 }, 'frame1');

          this.menuOpen = true;
      }

      
    }

  }
}
</script>
